import * as actionTypes from "../types/types";

export const initialState = {
  searchQuery: "",
  ingredients: [],
  ingredientErrors: {
    existingIngredient: false,
    invalidIngredient: false,
    invalidKeyword: false,
    emptyIngredients: false,
    emptyQuery: false,
  },
  inputValue: "",
  recipes: [],
  loading: false,
  loaded: 0,
  error: null,
  popup: {
    open: false,
    selectedRecipe: null,
  },
  showSearchButton: false,
  nextPageUrl: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.payload,
      };
    case actionTypes.ADD_INGREDIENT:
      return {
        ...state,
        ingredients: [...state.ingredients, action.payload],
      };
    case actionTypes.REMOVE_INGREDIENT:
      return {
        ...state,
        ingredients: state.ingredients.filter(
          (ingredient) => ingredient !== action.payload,
        ),
      };
    case actionTypes.SET_INGREDIENT_ERROR:
      return {
        ...state,
        ingredientErrors: {
          ...state.ingredientErrors,
          [action.payload.errorType]: action.payload.isError,
        },
      };
    case actionTypes.SET_INPUT_VALUE:
      return {
        ...state,
        inputValue: action.payload,
      };
    case actionTypes.FETCH_RECIPES_START:
      return { ...state, loading: true, error: null, loaded: state.loaded + 1 };
    case actionTypes.FETCH_RECIPES_SUCCESS:
      return {
        ...state,
        recipes: [...state.recipes, ...action.payload],
        loading: false,
        error: null,
      };
    case actionTypes.FETCH_RECIPES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actionTypes.OPEN_POPUP:
      return {
        ...state,
        popup: {
          ...state.popup,
          open: true,
        },
      };
    case actionTypes.CLOSE_POPUP:
      return {
        ...state,
        popup: {
          ...state.popup,
          open: false,
          selectedRecipe: null,
          loading: 2,
        },
      };
    case actionTypes.SET_SELECTED_RECIPE:
      return {
        ...state,
        popup: {
          ...state.popup,
          selectedRecipe: action.payload,
        },
      };
    case actionTypes.TOGGLE_SEARCH_BUTTON:
      return {
        ...state,
        showSearchButton: true,
      };
    case actionTypes.SET_NEXT_PAGE_URL:
      return {
        ...state,
        nextPageUrl: action.payload,
      };
    default:
      return state;
  }
};

export default searchReducer;
